import React, { useState, useEffect } from "react";
import home_background1 from "../../Assets/Images/home/banner.png";
import "./home.css";
import OurServices from "../../Components/Home/OurServices/OurServices";
import MissionStatement from "../../Components/Home/MissionStatement/MissionStatement";
import UpcomingEvents from "../../Components/Home/UpcomingEvents/UpcomingEvents";
import Loader from "../../Components/Loader/Loader";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer";
import Packages from "../../Components/Home/Packages/Packages";
import Instructors from "../../Components/Home/Instructors/Instructors";
import Gallery from "../../Components/Home/Gallery/Gallery";
import Sponsors from "../../Components/Home/Sponsers/Sponsers";
import { InstructionsContextProvider } from "../../APIContext/InstructionsContext";

import hero_banner from "../../Assets/Images/home/HomepgaeHeroBg.png";

import mission_bg from "../../Assets/Images/home/mission_bg.png";
import SEO from "../../Components/SEO";

const Home = () => {
  const navigate = useNavigate();
  const user = localStorage.getItem("user");
  const images = [home_background1];
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);
  return (
    <>
      <SEO
        title="Home - Shootin School Basketball"
        description=""
        url="https://shootinschool.com/"
      />

      <div
        className="banner-section"
        style={{ backgroundImage: `url(${hero_banner})` }}
      >
        <div className="section-full-w-row">
          <div className="section-boxed-w-row">
            <div className="home-container home">
              <div className="banner-content">
                <h2 className="text-clip">STATEN ISLAND’S PREMIER</h2>
                <h1
                  className="text-clip"
                  style={{ "--drop-shadow": "#FFA83E" }}
                >
                  BASKETBALL
                </h1>
                <span className="banner-intro">Instruction</span>
                <div className="custom-btn home">
                  <Link to="/instruction/">Purchase Your Session Now</Link>
                  {user ? (
                    <Link to="/your-packages">Schedule Your Session Now</Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="banner-section mission"
        style={{ backgroundImage: `url(${mission_bg})` }}
      >
        <div className="section-full-w-row">
          <div className="section-boxed-w-row">
            <div className="home-container mission">
              <div className="banner-content mission">
                <h2>Our Mission</h2>
                <p className="text-clip">
                  “Don’t just read about it — see how we take players to the
                  next level.”
                </p>
                <MissionStatement />
              </div>
            </div>
          </div>
        </div>
      </div>

      <InstructionsContextProvider>
        <Packages />
      </InstructionsContextProvider>

      <UpcomingEvents />
      <Instructors />
      <Gallery />
      <Sponsors />
    </>
  );
};
export default Home;
